import React, { useEffect } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import withReducer from '@Hooks/withReducer';
import { withRouter } from 'react-router-dom';
import { withCombinedRouteParams } from '@AppRoutes/ConnectedRoute';
import RouteChangeTracking from '@Services/RouteChangeTracking';
import QuickResultsReducer from './QuickResultsReducer';
import { quickResultsReducerKey } from './QuickResultsConstants';
import QuickResults from './QuickResults';
import {
  isLoading as isLoadingSelector,
  allResults as allResultsSelector,
  previewResults as previewResultsSelector,
  structure as structureSelector,
  structurePreview as structurePreviewSelector,
  query as querySelector,
  isQueryEnabled as isQueryEnabledSelector,
  isBioactivityVisualizationButtonEnabled as isBioactivityVisualizationButtonEnabledSelector,
  searchId as searchIdSelector,
} from './QuickResultsSelectors';

import {
  trackPreviewFeature,
  initialize,
  cancelSubscriptions,
  showMoreResults,
  cancelQueriesInGroup,
  createAlert,
  copyQuery,
  getEditInQueryBuilderButtonAttrs,
  cancelQuery,
  goToNewSearch,
  goToEditSearch,
  showStructurePopup,
  redirectToResults,
} from './QuickResultsActions';

const mapStateToProps = (state) => ({
  isLoading: isLoadingSelector(state),
  allResults: allResultsSelector(state),
  previewResults: previewResultsSelector(state),
  structure: structureSelector(state),
  structurePreview: structurePreviewSelector(state),
  query: querySelector(state),
  isQueryEnabled: isQueryEnabledSelector(state),
  isBioactivityVisualizationButtonEnabled: isBioactivityVisualizationButtonEnabledSelector(state),
  searchId: searchIdSelector(state),
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  initialize: () => dispatch(initialize({ ...ownProps })),
  cancelSubscriptions: () => dispatch(cancelSubscriptions()),
  showMoreResults: (resultItem) => dispatch(showMoreResults(resultItem)),
  cancelQueriesInGroup: (groupId) => dispatch(cancelQueriesInGroup(groupId)),
  cancelQuery: (queryId, isError) => dispatch(cancelQuery(queryId, isError)),
  showStructurePopup: (structurePreview) => dispatch(showStructurePopup(structurePreview)),
  goToNewSearch: () => dispatch(goToNewSearch()),
  goToEditSearch: () => dispatch(goToEditSearch()),
  redirectToResults: (requestParams, buttonIndex) => dispatch(redirectToResults(requestParams, ownProps.history, buttonIndex)),
  trackPreviewFeature,
  createAlert,
  copyQuery,
  getEditInQueryBuilderButtonAttrs,
});

function QuickResultsContainer(props) {
  useEffect(() => {
    RouteChangeTracking.trackOnRouteChangeSuccess();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return <QuickResults {...props} />;
}

export default compose(
  withCombinedRouteParams,
  withRouter,
  withReducer(quickResultsReducerKey, QuickResultsReducer),
  connect(mapStateToProps, mapDispatchToProps)
)(QuickResultsContainer);
